<div class="list-item">
  <app-photo
    size="m"
    [rounded]="true"
    [type]="'photo'"
    [id]="data?.photoId"
    [text]="data?.shortName || ''"
    [showPreview]="false"
  ></app-photo>

  <div class="list-item__info">
    <div class="list-item__title">
      <span class="list-item__text text_size-m text_color-01 text_line-2">
        {{ data?.shortName }}
      </span>
    </div>

    <span
      *ngIf="data?.businessTypesComplected"
      class="list-item__text text_size-xs text_color-03 text_truncate text_line-2"
    >
      {{ data?.businessTypesComplected }}
    </span>
  </div>
</div>
